import React, { useState } from "react";
import { MailServerSettings } from "@/components/MailServerSettings";
import { MailSignatureEditor } from "@/components/MailSignatureEditor";
import { MailTemplateManager } from "@/components/MailTemplateManager";
import { MailEditorSettingsCard } from "@/components/MailEditorSettingsCard";
import { EmailLogsCard } from "@/components/EmailLogsCard";
import ImportChildrenForm from "@/components/ImportChildrenForm";
import ImportHistoryTable from "@/components/ImportHistoryTable";
import { TrainingSectionsConfig } from "@/components/TrainingSectionsConfig";
import { FAQManager } from "@/components/FAQManager";
import { FontSettingsManager } from "@/components/FontSettingsManager";
import { DeviceBreakpointsConfig } from "@/components/DeviceBreakpointsConfig";
import { FooterSettingsManager } from "@/components/FooterSettingsManager";
import { SessionSettingsManager } from "@/components/SessionSettingsManager";
import { BackupManager } from "@/components/BackupManager";
import { NavigationColorSettings } from "@/components/NavigationColorSettings";
import { GroupColorPresetsManager } from "@/components/GroupColorPresetsManager";
import { TwoFactorEmailTemplate } from "@/components/TwoFactorEmailTemplate";
import { MaintenanceTools } from "@/components/MaintenanceTools";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

const SECTIONS = [
  { id: "training", label: "Leistungsstand", icon: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" },
  { id: "backup", label: "Backup", icon: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" },
  { id: "maintenance", label: "Wartung", icon: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z" },
  { id: "2fa-email", label: "2FA E-Mail", icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" },
  { id: "navigation", label: "Navigation", icon: "M4 6h16M4 12h16M4 18h16" },
  { id: "group-colors", label: "Gruppenfarben", icon: "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" },
  { id: "fonts", label: "Schriftarten", icon: "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" },
  { id: "devices", label: "Geräte", icon: "M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" },
  { id: "session", label: "Session", icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" },
  { id: "footer", label: "Footer", icon: "M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2zM3 17h18" },
  { id: "faq", label: "FAQ / Hilfe", icon: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
  { id: "mail-server", label: "Mailserver", icon: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" },
  { id: "mail-signature", label: "Signatur", icon: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" },
  { id: "mail-templates", label: "Vorlagen", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" },
  { id: "mail-editor", label: "Editor", icon: "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" },
  { id: "email-logs", label: "E-Mail-Protokoll", icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" },
  { id: "import", label: "Import", icon: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" },
];

export function SystemSettingsTabModern({
  authToken,
  groups,
  imports,
  fetchImports,
  fetchChildren,
  isSuperAdmin,
}) {
  const [activeSection, setActiveSection] = useState("training");
  const [expandedSections, setExpandedSections] = useState(["training"]);

  if (!isSuperAdmin) {
    return (
      <div className="rounded-xl bg-amber-50 p-6 text-center">
        <p className="text-sm text-amber-700">Nur Super-Administratoren können Systemeinstellungen verwalten.</p>
      </div>
    );
  }

  const toggleSection = (sectionId) => {
    setExpandedSections((prev) =>
      prev.includes(sectionId) ? prev.filter((id) => id !== sectionId) : [...prev, sectionId]
    );
    setActiveSection(sectionId);
  };

  return (
    <div className="space-y-4" data-testid="system-settings-tab-modern">
      {/* Header */}
      <div className="rounded-xl bg-white p-4 shadow-sm">
        <h2 className="text-lg font-semibold text-slate-900">Systemeinstellungen</h2>
        <p className="text-sm text-slate-500">Leistungsstand, Mail-Konfiguration, Vorlagen und Import-Funktionen</p>
      </div>

      {/* Navigation Pills */}
      <div className="flex flex-wrap gap-2 rounded-xl bg-white p-3 shadow-sm">
        {SECTIONS.map((section) => (
          <button
            key={section.id}
            data-testid={`section-${section.id}`}
            onClick={() => toggleSection(section.id)}
            className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-all ${
              activeSection === section.id
                ? "bg-violet-600 text-white"
                : "bg-slate-100 text-slate-600 hover:bg-slate-200"
            }`}
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={section.icon} />
            </svg>
            {section.label}
          </button>
        ))}
      </div>

      {/* Leistungsstand-Konfiguration */}
      {activeSection === "training" && (
        <TrainingSectionsConfig authToken={authToken} />
      )}

      {/* Backup */}
      {activeSection === "backup" && (
        <BackupManager authToken={authToken} />
      )}

      {/* Wartung & Optimierung */}
      {activeSection === "maintenance" && (
        <MaintenanceTools authToken={authToken} />
      )}

      {/* 2FA E-Mail */}
      {activeSection === "2fa-email" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-2fa-email">
          <div className="bg-gradient-to-r from-slate-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-slate-900">2FA E-Mail-Vorlage</h3>
            <p className="text-xs text-slate-500">E-Mail-Vorlage für den Verifikationscode bei der Zwei-Faktor-Authentifizierung</p>
          </div>
          <div className="p-4">
            <TwoFactorEmailTemplate authToken={authToken} />
          </div>
        </div>
      )}

      {/* Navigationsfarben */}
      {activeSection === "navigation" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-navigation">
          <div className="bg-gradient-to-r from-slate-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-slate-900">Navigationsfarben</h3>
            <p className="text-xs text-slate-500">Farben für aktive und Hover-Zustände der Navigation anpassen</p>
          </div>
          <div className="p-4">
            <NavigationColorSettings authToken={authToken} />
          </div>
        </div>
      )}

      {/* Gruppenfarben */}
      {activeSection === "group-colors" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-group-colors">
          <div className="bg-gradient-to-r from-slate-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-slate-900">Gruppenfarben</h3>
            <p className="text-xs text-slate-500">Vordefinierte Farben für die Gruppenauswahl</p>
          </div>
          <div className="p-4">
            <GroupColorPresetsManager authToken={authToken} />
          </div>
        </div>
      )}

      {/* Schriftarten & Größen */}
      {activeSection === "fonts" && (
        <FontSettingsManager authToken={authToken} />
      )}

      {/* Geräte-Breakpoints */}
      {activeSection === "devices" && (
        <DeviceBreakpointsConfig authToken={authToken} />
      )}

      {/* Session-Einstellungen (Auto-Logout) */}
      {activeSection === "session" && (
        <SessionSettingsManager authToken={authToken} />
      )}

      {/* Footer-Einstellungen */}
      {activeSection === "footer" && (
        <FooterSettingsManager authToken={authToken} />
      )}

      {/* FAQ / Hilfe */}
      {activeSection === "faq" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-faq">
          <div className="bg-gradient-to-r from-violet-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-violet-900">FAQ / Hilfe verwalten</h3>
            <p className="text-xs text-slate-500">Häufig gestellte Fragen für den Hilfe-Bereich erstellen</p>
          </div>
          <div className="p-4">
            <FAQManager authToken={authToken} />
          </div>
        </div>
      )}

      {/* Mailserver-Einstellungen */}
      {activeSection === "mail-server" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-mail-server">
          <div className="bg-gradient-to-r from-violet-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-violet-900">Mailserver-Einstellungen</h3>
            <p className="text-xs text-slate-500">SMTP-Konfiguration für den E-Mail-Versand</p>
          </div>
          <div className="p-4">
            <MailServerSettings authToken={authToken} />
          </div>
        </div>
      )}

      {/* Mail-Signatur */}
      {activeSection === "mail-signature" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-mail-signature">
          <div className="bg-gradient-to-r from-violet-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-violet-900">Mail-Signatur</h3>
            <p className="text-xs text-slate-500">Standard-Signatur für alle E-Mails</p>
          </div>
          <div className="p-4">
            <MailSignatureEditor authToken={authToken} />
          </div>
        </div>
      )}

      {/* Mail-Vorlagen */}
      {activeSection === "mail-templates" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-mail-templates">
          <div className="bg-gradient-to-r from-violet-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-violet-900">Mail-Vorlagen</h3>
            <p className="text-xs text-slate-500">Wiederverwendbare E-Mail-Vorlagen erstellen</p>
          </div>
          <div className="p-4">
            <MailTemplateManager authToken={authToken} />
          </div>
        </div>
      )}

      {/* Mail-Editor-Einstellungen */}
      {activeSection === "mail-editor" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-mail-editor">
          <div className="bg-gradient-to-r from-violet-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-violet-900">Mail-Editor-Einstellungen</h3>
            <p className="text-xs text-slate-500">Farben, Schriften und Formatierungsoptionen</p>
          </div>
          <div className="p-4">
            <MailEditorSettingsCard authToken={authToken} />
          </div>
        </div>
      )}

      {/* E-Mail-Protokoll */}
      {activeSection === "email-logs" && (
        <div className="rounded-xl bg-white shadow-sm overflow-hidden" data-testid="section-content-email-logs">
          <div className="bg-gradient-to-r from-violet-50 to-white px-4 py-3 border-b border-slate-100">
            <h3 className="text-base font-bold text-violet-900">E-Mail-Protokoll</h3>
            <p className="text-xs text-slate-500">Verlauf aller gesendeten E-Mails</p>
          </div>
          <div className="p-4">
            <EmailLogsCard authToken={authToken} />
          </div>
        </div>
      )}

      {/* Import */}
      {activeSection === "import" && (
        <div className="space-y-4" data-testid="section-content-import">
          <div className="rounded-xl bg-white shadow-sm overflow-hidden">
            <div className="bg-gradient-to-r from-violet-50 to-white px-4 py-3 border-b border-slate-100">
              <h3 className="text-base font-bold text-violet-900">Kinder importieren</h3>
              <p className="text-xs text-slate-500">XLSX-Dateien mit Kinderdaten hochladen</p>
            </div>
            <div className="p-4">
              <ImportChildrenForm
                apiBase={API_BASE}
                authHeaders={() => ({ headers: { Authorization: `Bearer ${authToken}` } })}
                groups={groups}
                onImported={() => {
                  fetchImports?.();
                  fetchChildren?.();
                }}
              />
            </div>
          </div>

          <div className="rounded-xl bg-white shadow-sm overflow-hidden">
            <div className="bg-gradient-to-r from-slate-50 to-white px-4 py-3 border-b border-slate-100">
              <h3 className="text-base font-bold text-slate-900">Import-Verlauf</h3>
              <p className="text-xs text-slate-500">Bisherige Importe und deren Status</p>
            </div>
            <div className="p-4">
              <ImportHistoryTable 
                imports={imports || []} 
                groups={groups || []}
                formatDateISOToGerman={(d) => {
                  if (!d) return "";
                  try {
                    return format(parseISO(d), "dd.MM.yyyy", { locale: de });
                  } catch {
                    return d;
                  }
                }}
                onRefresh={fetchImports}
                apiBase={API_BASE}
                authHeaders={() => authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : {}}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
